// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"2CoGE":[function(require,module,exports,__globalThis) {
var _localizationFormScss = require("../scss/localization-form.scss");
if (!customElements.get('localization-form')) customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor(){
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header__wrapper');
        this.elements = {
            input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
            button: this.querySelector('button.localization-form__select'),
            panel: this.querySelector('.disclosure__list-wrapper'),
            search: this.querySelector('input[name="country_filter"]'),
            closeButton: this.querySelector('.country-selector__close-button'),
            resetButton: this.querySelector('.country-filter__reset-button'),
            searchIcon: this.querySelector('.country-filter__search-icon'),
            liveRegion: this.querySelector('#sr-country-search-results')
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        if (this.elements.button) this.elements.button.addEventListener('click', this.openSelector.bind(this));
        if (this.elements.search) {
            this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
            this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
            this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
            this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        if (this.elements.resetButton) {
            this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
            this.elements.resetButton.addEventListener('mousedown', (event)=>event.preventDefault());
        }
        this.querySelectorAll('a').forEach((item)=>item.addEventListener('click', this.onItemClick.bind(this)));
    }
    hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
            this.elements.search.value = '';
            this.filterCountries();
            this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
    }
    onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter((item)=>!item.parentElement.classList.contains('hidden'));
        let focusedItemIndex = focusableItems.findIndex((item)=>item === document.activeElement);
        let itemToFocus;
        switch(event.code.toUpperCase()){
            case 'ARROWUP':
                event.preventDefault();
                itemToFocus = focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
                itemToFocus.focus();
                break;
            case 'ARROWDOWN':
                event.preventDefault();
                itemToFocus = focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
                itemToFocus.focus();
                break;
        }
        if (!this.elements.search) return;
        setTimeout(()=>{
            focusedItemIndex = focusableItems.findIndex((item)=>item === document.activeElement);
            if (focusedItemIndex > -1) this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
            else this.elements.search.setAttribute('aria-activedescendant', '');
        });
    }
    onContainerKeyUp(event) {
        event.preventDefault();
        switch(event.code.toUpperCase()){
            case 'ESCAPE':
                if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
                this.hidePanel();
                event.stopPropagation();
                this.elements.button.focus();
                break;
            case 'SPACE':
                if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
                this.openSelector();
                break;
        }
    }
    onItemClick(event) {
        console.log('click item');
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
    }
    openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
        if (!document.body.classList.contains('overflow-hidden-tablet')) document.body.classList.add('overflow-hidden-mobile');
        if (this.elements.search && this.mql.matches) this.elements.search.focus();
        if (this.hasAttribute('data-prevent-hide')) this.header.preventHide = true;
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
    }
    closeSelector(event) {
        if (event.target.classList.contains('country-selector__overlay') || !this.contains(event.target) || !this.contains(event.relatedTarget)) this.hidePanel();
    }
    normalizeString(str) {
        return str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
    }
    filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;
        this.elements.resetButton.classList.toggle('hidden', !searchValue);
        if (popularCountries) popularCountries.classList.toggle('hidden', searchValue);
        allCountries.forEach((item)=>{
            const countryName = this.normalizeString(item.querySelector('.country').textContent);
            if (countryName.indexOf(searchValue) > -1) {
                item.parentElement.classList.remove('hidden');
                visibleCountries++;
            } else {
                item.parentElement.classList.add('hidden');
                visibleCountries--;
            }
        });
        if (this.elements.liveRegion) this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace('[count]', visibleCountries);
        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
    }
    resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
    }
    onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
    }
    onSearchBlur() {
        if (!this.elements.search.value) this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
    }
    onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') event.preventDefault();
    }
});

},{"../scss/localization-form.scss":"kCIfk"}],"kCIfk":[function() {},{}]},["2CoGE"], "2CoGE", "parcelRequire7cb6", {})

//# sourceMappingURL=localization-form.js.map
